import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import axios from "axios";
import { getToken, base_url } from "../../config/config";

const ShiftTable = () => {
  const [shifts, setShifts] = useState([]);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedShift, setSelectedShift] = useState(null);

  useEffect(() => {
    // Fetch shifts from the backend
    const fetchShifts = async () => {
      try {
        const response = await axios.get(`${base_url}/v1/getshifts`);
        setShifts(response.data);
      } catch (error) {
        console.error("Error fetching shifts:", error);
      }
    };
    fetchShifts();
  }, []);

  // Handle Edit Dialog open
  const handleEditOpen = (shift) => {
    setSelectedShift(shift);
    setIsEditOpen(true);
  };

  // Handle Edit Dialog close
  const handleEditClose = () => {
    setSelectedShift(null);
    setIsEditOpen(false);
  };

  // Handle Edit Form Change
  const handleEditChange = (event) => {
    const { name, value } = event.target;
    setSelectedShift((prevShift) => ({
      ...prevShift,
      [name]: value,
    }));
  };

  // Handle Save Changes (edit)
  const handleSaveEdit = async () => {
    try {
      const response = await axios.put(
        `${base_url}/v1/updateShift/${selectedShift._id}`,
        selectedShift,
      );
      setShifts((prevShifts) =>
        prevShifts.map((shift) =>
          shift._id === selectedShift._id ? response.data.shift : shift,
        ),
      );
      handleEditClose();
    } catch (error) {
      console.error("Error updating shift:", error);
    }
  };

  // Handle Delete
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${base_url}/v1/deleteShift/${id}`);
      setShifts((prevShifts) => prevShifts.filter((shift) => shift._id !== id));
    } catch (error) {
      console.error("Error deleting shift:", error);
    }
  };

  const columns = [
    {
      accessorKey: "name",
      header: "Shift Name",
    },
    {
      accessorKey: "startTime",
      header: "Start Time",
    },
    {
      accessorKey: "endTime",
      header: "End Time",
    },
    {
      accessorKey: "days",
      header: "Days",
      Cell: ({ cell }) => cell.getValue().join(", "),
    },
    {
      accessorKey: "breaks",
      header: "Breaks",
      Cell: ({ cell }) =>
        cell
          .getValue()
          .map((breakTime) => `${breakTime.breakStart} - ${breakTime.breakEnd}`)
          .join(", "),
    },
    {
      header: "Actions",
      Cell: ({ row }) => (
        <Box>
          <IconButton onClick={() => handleEditOpen(row.original)}>
            <Edit />
          </IconButton>
          <IconButton onClick={() => handleDelete(row.original._id)}>
            <Delete />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ padding: "2rem" }}>
      <MaterialReactTable columns={columns} data={shifts} />

      {/* Edit Shift Dialog */}
      {isEditOpen && (
        <Dialog open={isEditOpen} onClose={handleEditClose}>
          <DialogTitle>Edit Shift</DialogTitle>
          <DialogContent>
            <TextField
              margin='dense'
              label='Shift Name'
              name='name'
              value={selectedShift?.name || ""}
              onChange={handleEditChange}
              fullWidth
            />
            <TextField
              margin='dense'
              label='Start Time'
              type='time'
              name='startTime'
              value={selectedShift?.startTime || ""}
              onChange={handleEditChange}
              fullWidth
            />
            <TextField
              margin='dense'
              label='End Time'
              type='time'
              name='endTime'
              value={selectedShift?.endTime || ""}
              onChange={handleEditChange}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleEditClose} color='secondary'>
              Cancel
            </Button>
            <Button onClick={handleSaveEdit} color='primary'>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default ShiftTable;
